import { render, staticRenderFns } from "./AnalyticsYandex.vue?vue&type=template&id=4c1beee4&"
import script from "./AnalyticsYandex.vue?vue&type=script&lang=js&"
export * from "./AnalyticsYandex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports